import type { Span } from '@opentelemetry/api';

const TRACE_USER_ID_KEY = '__BTS_TRACE_USER_ID__';

export const setSpanUserId = (span: Span | undefined, userId?: string) => {
  if (!span || !userId) {
    return;
  }

  span.setAttribute('usr.id', userId);
};

export const setClientTraceUserId = (userId?: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (userId) {
    (globalThis as typeof globalThis & { [TRACE_USER_ID_KEY]?: string })[
      TRACE_USER_ID_KEY
    ] = userId;

    return;
  }

  delete (globalThis as typeof globalThis & { [TRACE_USER_ID_KEY]?: string })[
    TRACE_USER_ID_KEY
  ];
};

export const getClientTraceUserId = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const value = (
    globalThis as typeof globalThis & { [TRACE_USER_ID_KEY]?: string }
  )[TRACE_USER_ID_KEY];

  return typeof value === 'string' && value.length > 0 ? value : undefined;
};
